import {AnalysisGraphQL, AnalysisViewGraphQL} from 'analysis-tool/AnalysisTypes';
import getAdditionalDataFrameMetadataModalContent from 'analysis-tool/data-frame-metadata/getDataFrameMetadataModalContent';
import {isDataFrameView} from 'analysis-tool/data-view/AnalysisViewUtils';
import {DataViewContextValue} from 'analysis-tool/data-view/DataViewContext';

export default function getAdditionalMetadataContent(
  analysis: AnalysisGraphQL,
  view: AnalysisViewGraphQL
): DataViewContextValue['additionalMetadataContent'] {
  if (isDataFrameView(view)) {
    return getAdditionalDataFrameMetadataModalContent(
      analysis.steps.find(({id}) => id === view.lineage[0].step.id)!
    );
  }

  return undefined;
}
